import { gql, useMutation } from "@apollo/client";

const DELETE_PROJECT_FILE = gql`
  mutation DeleteProjectFile($projectId: ID!) {
    deleteProjectFile(projectId: $projectId)
  }
`;

export const useDeleteProjectFileMutation = () => {
  const [deleteProjectFileMutation, { loading, error, data }] =
    useMutation(DELETE_PROJECT_FILE);

  const deleteProjectFile = async (projectId: string) => {
    try {
      const response = await deleteProjectFileMutation({
        variables: { projectId },
      });
      return response.data?.deleteProjectFile ?? false;
    } catch (deleteError) {
      console.error("Error deleting project file:", deleteError);
      throw deleteError;
    }
  };

  return {
    deleteProjectFile,
    loading,
    error,
    data,
  };
};
